import { isSlideNotAnamneseSlide } from '@llx/common';
import { PatientCaseContent } from '@llx/common';

export const getIndexFirstSlideNotAnamnese = (patientCase: PatientCaseContent) => {
  return patientCase.slides.findIndex(isSlideNotAnamneseSlide);
};
